module.exports = __webpack_public_path__ + "static/img/home_02.eea3e8a.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imges/home_02.jpg
// module id = 1O64
// module chunks = 1